import { LessonsByCompetency, useDistrictCompetencyRatingQuery } from '@src/api/graphql-codegen'
import styles from './UsageView.module.scss'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type Props = {
  fromDate: string
  toDate: string
  filterSchools: string[]
  filterGrades: string[]
  noData?: boolean | false;
  completedLessons?: LessonsByCompetency;
  totalCompleted?: number | null;
}

const calculateCompetencyPercent = (lessons: LessonsByCompetency, competency: number) => {
  const values = [
    lessons.relationshipSkills ?? 0,
    lessons.responsibleDecisionMaking ?? 0,
    lessons.selfAwareness ?? 0,
    lessons.selfManagement ?? 0,
    lessons.socialAwareness ?? 0,
  ];

  const maxValue = Math.max(1, ...values);

  return Math.round((competency / maxValue) * 100);
}

function CompetencyRating(props: Props) {

  const {data, loading} = useDistrictCompetencyRatingQuery({
    fetchPolicy: "cache-first",
    variables: {
      input: {
        fromDate: props.fromDate,
        toDate: props.toDate,
        schoolIds: props.filterSchools,
        ageGroups: props.filterGrades,
      }
    },
    skip: !props.filterSchools.length
  })

  const scoreContent = (label: string, score: number) => {
    const color = score >= 80 ? '#BCE5C5' : (score >= 50 ? '#FFE7AB' : '#FFBEBE')
    return (
      <div className={styles.ratingProgressContainer}>
        <div className={styles.ratingProgressBox}>
          <div className={styles.ratingProgressBar} style={{backgroundColor: color, height: `${score}%`}}></div>
          <div className={styles.ratingProgressLabel} style={{top: 18}}>{label}</div>
          <div className={styles.ratingProgressScore} style={{bottom: 30}}>{score}%</div>
        </div>
      </div>
    )
  }

  const lessonCompleted = (label: string, score: number, lessons: number) => {
    
    return (
      <div className={styles.competencyLessonCompletedContainer}>
        <div className={styles.completedProgressBox}>
          <div className={styles.completedProgressBar} style={{width: `${score}%`}}></div>
          <div className={styles.competencyLabel} >{label}</div>
          <div className={styles.completedLessons} >{lessons}</div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.boxWrapper}>
      {loading ? <div><Skeleton height={20} highlightColor="#ffb073" /></div> : <>
        <div className={styles.headerLabel}>Competency Rating</div>
        <div className={styles.ratingContainer} style={{filter: props.noData ? 'blur(5px)' : ''}}>
          <div className={styles.flexBox}>
            {scoreContent('Relationship Skills', props.noData ? 82 : data?.districtCompetencyRating?.relationshipSkills ?? 0)}
            {scoreContent('Responsible Decision-Making', props.noData ? 80 : data?.districtCompetencyRating?.responsibleDecisionMaking ?? 0)}
            {scoreContent('Self-Awareness', props.noData ? 24 : data?.districtCompetencyRating?.selfAwareness ?? 0)}
            {scoreContent('Self-Management', props.noData ? 64 : data?.districtCompetencyRating?.selfManagement ?? 0)}
            {scoreContent('Social Awareness', props.noData ? 48 : data?.districtCompetencyRating?.socialAwareness ?? 0)}
          </div>
        </div>
        <div className={styles.competencyLessonCompletedWrapper} style={{filter: props.noData ? 'blur(5px)' : ''}}>
          <span className={styles.subTitle}># of Completed Lessons per Competency</span>
          {props.completedLessons && lessonCompleted('Relationship Skills', calculateCompetencyPercent(props.completedLessons, props.completedLessons?.relationshipSkills || 0), props.completedLessons?.relationshipSkills || 0)}
          {props.completedLessons && lessonCompleted('Responsible Decision-Making', calculateCompetencyPercent(props.completedLessons, props.completedLessons?.responsibleDecisionMaking || 0), props.completedLessons?.responsibleDecisionMaking || 0)}
          {props.completedLessons && lessonCompleted('Self-Awareness', calculateCompetencyPercent(props.completedLessons, props.completedLessons?.selfAwareness || 0), props.completedLessons?.selfAwareness || 0)}
          {props.completedLessons && lessonCompleted('Self-Management', calculateCompetencyPercent(props.completedLessons, props.completedLessons?.selfManagement || 0), props.completedLessons?.selfManagement || 0)}
          {props.completedLessons && lessonCompleted('Social Awareness', calculateCompetencyPercent(props.completedLessons, props.completedLessons?.socialAwareness || 0), props.completedLessons?.socialAwareness || 0)}
        </div>
      </>}
    </div>
  )
}

export default CompetencyRating